import { TimeZoneOutputWithStatus } from './time-zone-output-with-status.model';


export class TimeZoneSelectByIdOutput implements ITimeZoneSelectByIdOutput {
    status!: number;
    message!: string;
    data!: TimeZoneOutputWithStatus;

    constructor(data?: ITimeZoneSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? TimeZoneOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeZoneSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITimeZoneSelectByIdOutput {
    status: number;
    message: string;
    data: TimeZoneOutputWithStatus;
}

